import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Star, Check } from 'lucide-react';
export function Pricing() {
  return <Section id="pricing" className="bg-white" data-id="element-158">
      <div className="max-w-lg mx-auto bg-white rounded-3xl shadow-2xl border-2 border-brand-pink overflow-hidden transform hover:scale-105 transition-transform duration-300" data-id="element-159">
        <div className="bg-brand-pink p-4 text-center" data-id="element-160">
          <span className="text-brand-dark font-bold text-sm uppercase tracking-wider" data-id="element-161">
            Oferta Especial de Lanzamiento
          </span>
        </div>

        <div className="p-8 md:p-10 text-center" data-id="element-162">
          <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-163">
            Mamá Digital 2.0
          </h2>
          <p className="text-gray-500 mb-6" data-id="element-164">
            Tu primer producto digital puede ser más simple de lo que imaginas
          </p>

          <div className="flex items-center justify-center mb-8" data-id="element-165">
            <span className="text-gray-400 text-2xl line-through mr-4" data-id="element-166">
              $97
            </span>
            <span className="text-5xl font-extrabold text-brand-pink" data-id="element-167">
              $6.39
            </span>
            <span className="text-gray-500 text-xl ml-2" data-id="element-168">USD</span>
          </div>

          <div className="text-left bg-gray-50 p-6 rounded-xl mb-8" data-id="element-169">
            <p className="font-bold text-gray-900 mb-4" data-id="element-170">Estás comprando:</p>
            <ul className="space-y-3" data-id="element-171">
              {['Un método que te dice qué crear', 'Cómo estructurarlo para que se vea profesional', 'Cómo terminarlo rápido sin quemarte', 'Cómo venderlo sin sentirte incómoda'].map((item, i) => <li key={i} className="flex items-start text-gray-700 text-sm" data-id="element-172">
                  <Check className="w-4 h-4 text-emerald-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-173" />
                  <span data-id="element-174">{item}</span>
                </li>)}
            </ul>
          </div>

          <Button fullWidth className="mb-4 bg-brand-pink hover:bg-rose-400 text-brand-dark font-bold" data-id="element-175">
            Sí, quiero Mamá Digital 2.0
          </Button>

          <p className="text-xs text-gray-400 mb-6" data-id="element-176">
            Descarga inmediata • Empieza hoy • Solo necesitas tu celular
          </p>

          <div className="flex items-center justify-center text-sm text-gray-500 bg-gray-50 py-3 rounded-lg" data-id="element-177">
            <ShieldCheck className="w-5 h-5 text-emerald-500 mr-2" data-id="element-178" />
            <span data-id="element-179">Garantía de satisfacción de 30 días</span>
          </div>
        </div>
      </div>
    </Section>;
}